{
  "clear": "Kustuta",
  "invalid": "(kehtetu)",
  "loading": "Laadimine...",
  "noResults": "Tulemusi pole"
}
